import React, { useState, useEffect } from 'react';
import AdminLayout from '../../components/AdminLayout';
import { Users, Plane, FileText, TrendingUp, DollarSign, Percent } from 'lucide-react';

const AdminDashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const token = localStorage.getItem('adminToken');
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/admin/stats`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setStats(data);
      }
    } catch (error) {
      console.error('Erreur:', error);
    } finally {
      setLoading(false);
    }
  };

  const statCards = stats ? [
    {
      icon: Users,
      label: 'Membres Actifs',
      value: stats.active_members,
      total: stats.total_members,
      color: '#2c5f7d'
    },
    {
      icon: Plane,
      label: 'Vols Actifs',
      value: stats.active_flights,
      total: stats.total_flights,
      color: '#8b4f6d'
    },
    {
      icon: FileText,
      label: 'Devis en Attente',
      value: stats.pending_quotes,
      color: '#c41e3a'
    },
    {
      icon: DollarSign,
      label: 'Revenus Totaux',
      value: `${stats.total_revenue.toLocaleString('fr-FR')} €`,
      color: '#2c5f7d'
    },
    {
      icon: Percent,
      label: 'Taux de Remplissage',
      value: `${stats.fill_rate}%`,
      color: '#8b4f6d'
    }
  ] : [];

  return (
    <AdminLayout>
      <div style={{ padding: '32px' }}>
        <h1 className="hero-medium" style={{ marginBottom: '32px' }}>Dashboard</h1>

        {loading ? (
          <p>Chargement...</p>
        ) : (
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '24px'
          }}>
            {statCards.map((card, index) => {
              const Icon = card.icon;
              return (
                <div
                  key={index}
                  style={{
                    background: 'var(--bg-primary)',
                    border: '1px solid var(--border-light)',
                    padding: '24px'
                  }}
                >
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    marginBottom: '16px'
                  }}>
                    <Icon size={24} color={card.color} />
                    <span className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                      {card.label}
                    </span>
                  </div>
                  <div>
                    <span className="hero-medium" style={{ color: card.color }}>
                      {card.value}
                    </span>
                    {card.total && (
                      <span className="body-small" style={{ color: 'var(--text-secondary)', marginLeft: '8px' }}>
                        / {card.total}
                      </span>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </AdminLayout>
  );
};

export default AdminDashboard;